<template lang="pug">
    v-tooltip(bottom :disabled="!disabledReason")
        template(v-slot:activator='{ on, attrs }')
            span(v-on='on' v-bind='attrs')
                v-btn.open-in-mykaarma-btn(
                    color="var(--volie-blue)"
                    small
                    text
                    :disabled="!canOpen"
                    :loading="isSaving"
                    @click="openInMyKaarma"
                )
                    span.open-in-mykaarma-label
                        span.open-in-mykaarma-first-line
                            v-icon(dark small) mdi-open-in-new
                            | Open in
                        span.open-in-mykaarma-second-line MyKaarma
        span {{ disabledReason }}
</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { OpenInMyKaarma } from "@/data";

    export default Vue.extend({
        data() {
            return {
                isSaving: false,
            }
        },
        methods: {
            openInMyKaarma() {
                if (!this.canOpen) {
                    return;
                }

                this.isSaving = true;
                OpenInMyKaarma({
                    campaign_id: this.campaignId || 0,
                    customer_id: this.customerId,
                    notification_context: this.resolvedNotificationContext,
                    phone_number: this.phoneNumber || '',
                }).then((response) => {
                    if (response?.Error?.length > 0) {
                        this.showSnackbar("red", response.Error);
                        return;
                    }
                    if (response?.Data?.result?.notification_sent) {
                        this.showSnackbar("green", "Opened in MyKaarma");
                        return;
                    }
                    this.showSnackbar("red", "Unable to open in MyKaarma");
                }).catch(() => {
                    this.showSnackbar("red", "Unable to open in MyKaarma");
                }).finally(() => {
                    this.isSaving = false;
                });
            },
        },
        computed: {
            canOpen(): boolean {
                return this.customerId > 0 && !this.isSaving;
            },
            disabledReason(): string {
                if (!(this.customerId > 0)) {
                    return "Load a customer to open in MyKaarma";
                }
                return "";
            },
            resolvedNotificationContext(): string {
                switch (this.notificationContext) {
                    case 'email':
                    case 'inbound_call':
                    case 'message':
                    case 'outbound_call':
                        return this.notificationContext;
                    default:
                        return 'outbound_call';
                }
            },
        },
        components: {},
        props: {
            campaignId: {
                type: Number,
                default: 0,
            },
            customerId: {
                type: Number,
                default: 0,
            },
            notificationContext: {
                type: String,
                default: 'outbound_call',
            },
            phoneNumber: {
                type: String,
                default: '',
            },
            showSnackbar: {
                type: Function,
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
.open-in-mykaarma-btn {
    height: auto !important;
    min-height: 28px;
}

.open-in-mykaarma-label {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.15;
    text-align: left;
}

.open-in-mykaarma-first-line {
    align-items: center;
    display: inline-flex;
    gap: 4px;
}

.open-in-mykaarma-second-line {
    padding-left: 20px;
}
</style>
